import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {APP_INITIALIZER, LOCALE_ID, NgModule} from '@angular/core';
import {ComponentsModule} from './components/components.module';
import {NgbDateParserFormatter, NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {ToastrModule} from 'ngx-toastr';
import {AppComponent} from './app.component';
import {GfxHttpInterceptor} from './services/GfxHttpInterceptor';
import {HTTP_INTERCEPTORS} from '@angular/common/http';
import {AppMenu} from './services/AppMenu';
import {PageNotFoundComponent} from './page-not-found/page-not-found.component';
import {AppConfig} from './services/AppConfig';
import {AppRoutingModule} from './app-routing.module';
import {NgbDtFrParserFormatterService} from './services/ngb-dt-fr-parser-formatter.service';
import {HashLocationStrategy, LocationStrategy, registerLocaleData} from '@angular/common';
import localeAr from '@angular/common/locales/ar-MR';
import {MenuConfig} from './services/MenuConfig';
import {GfxMaterialModule} from './components/gfx-material/gfx-material.module';
import {NgxSpinnerModule} from 'ngx-spinner';
import {FormsModule} from '@angular/forms';
import {BadgeTestModule} from './badge-test/badge-test.module';
import {CoreService} from './layouts/themes-strategies/vuely-strategy/admin-vuely-layout/comp/Core.service';
import {MenuItems} from './layouts/themes-strategies/vuely-strategy/admin-vuely-layout/comp/MenuItems';
import {MatStepperModule} from '@angular/material/stepper';
import {NgxIntlTelInputModule} from 'ngx-intl-tel-input';
import {MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter} from '@angular/material-moment-adapter';
import {UnderConstructionComponent} from './pages/under-construction/under-construction.component';
import {NgxMaskModule} from 'ngx-mask';
import {ProfileComponent} from './pages/profile/profile.component';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import localeFr from '@angular/common/locales/fr';
import 'moment/locale/fr';
import {AuthService} from './services/auth.service';
import {MarkdownModule} from 'ngx-markdown';
import { EspaceEntrepriseComponent } from './pages/espace-entreprise/espace-entreprise.component'; // Import French locale for Moment.js

registerLocaleData(localeAr, 'ar-MR');
registerLocaleData(localeFr, 'fr');

export function appConfigFactory(conf: AppConfig) {
    return () => conf.load();
}

export function menuConfigFactory(menu: MenuConfig) {
    return () => menu.load();
}

// Define French date formats for parsing and display
export const FRENCH_DATE_FORMATS = {
    parse: {
        dateInput: ['DD/MM/YYYY', 'D/M/YYYY', 'DD-MM-YYYY', 'DD.MM.YYYY', 'DDMMYYYY', 'D.M.YYYY', 'D-M-YYYY'],
    },
    display: {
        dateInput: 'DD/MM/YYYY', // Display format (e.g., 24/06/2025)
        monthYearLabel: 'MMMM YYYY', // Month label (e.g., "juin 2025")
        dateA11yLabel: 'LL', // Accessibility format (e.g., "24 juin 2025")
        monthYearA11yLabel: 'MMMM YYYY', // Accessibility month/year label
    },
};

@NgModule({
    declarations: [
        AppComponent,
        PageNotFoundComponent,
        UnderConstructionComponent,
        ProfileComponent,
        EspaceEntrepriseComponent
    ],
    imports: [
        BrowserAnimationsModule,
        AppRoutingModule,
        FormsModule,
        NgbModule,
        GfxMaterialModule,
        ToastrModule.forRoot(),
        ComponentsModule,
        NgxIntlTelInputModule,
        NgxSpinnerModule,
        BadgeTestModule,
        MatStepperModule,
        NgxMaskModule.forRoot(),
        MarkdownModule.forRoot(),
    ],
    providers: [
        {
            provide: APP_INITIALIZER,
            useFactory: appConfigFactory,
            deps: [AppConfig, AuthService],
            multi: true,
        },
        AppMenu,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: GfxHttpInterceptor,
            multi: true,
        },
        {
            provide: NgbDateParserFormatter,
            useClass: NgbDtFrParserFormatterService,
        },
        MenuItems,
        CoreService,
        {provide: LOCALE_ID, useValue: 'fr'}, // Set Angular locale to French
        {provide: MAT_DATE_LOCALE, useValue: 'fr'}, // Set Material Datepicker locale to French
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter, // Use Moment.js for date handling
            deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
        },
        {provide: MAT_DATE_FORMATS, useValue: FRENCH_DATE_FORMATS}, // Apply custom French date formats
        {provide: LocationStrategy, useClass: HashLocationStrategy},
        {
            provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS,
            useValue: {
                useUtc: true, // Use UTC for dates
                strict: false // Allow flexible date parsing (e.g., 1/1/2025, 01-01-2025)
            }
        }
    ],
    bootstrap: [AppComponent],
})
export class AppModule {
}
